import PageNotFound from './PageNotFound.component';

export default PageNotFound;
